"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.auth = void 0;

var _loginButton = _interopRequireDefault(require("./auth/containers/login-button"));

var _loginOptions = _interopRequireDefault(require("./auth/containers/login-options"));

var _girderLogin = _interopRequireDefault(require("./auth/containers/girder-login"));

var _oauthRedirect = _interopRequireDefault(require("./auth/containers/oauth-redirect"));

var _userMenu = _interopRequireDefault(require("./auth/containers/user-menu"));

var _nerscLogin = _interopRequireDefault(require("./auth/containers/nersc-login"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var auth = {
  LoginButton: _loginButton.default,
  LoginOptions: _loginOptions.default,
  GirderLogin: _girderLogin.default,
  OauthRedirect: _oauthRedirect.default,
  UserMenu: _userMenu.default,
  NerscLogin: _nerscLogin.default
};
exports.auth = auth;